module.exports = __webpack_public_path__ + "assets/img/first.304e4d1b.png";